import { useMemo } from 'react'
import { useLocation } from '@fs/zion-router'
import { useAppProvider } from '../providers/AppProvider'
import useIsInmate from './useIsInmate'

const useAppTabs = ({ showAdmin, showReports, showLabs }) => {
  const { isInmate } = useIsInmate()
  const { accessFromPrison, prisonReportsPermission } = useAppProvider()
  const { pathname } = useLocation()

  const tabs = useMemo(
    () => [
      { path: '/', show: !accessFromPrison && !isInmate },
      { path: '/opportunities', show: !accessFromPrison && !isInmate },
      { path: '/your-impact', show: !accessFromPrison && !isInmate },
      { path: '/indexing', show: !accessFromPrison && !isInmate },
      { path: '/reports', show: showReports && !accessFromPrison && !isInmate },
      { path: '/admin', show: showAdmin && !accessFromPrison && !isInmate },
      { path: '/labs', show: showLabs && !accessFromPrison && !isInmate },
      { path: '/prison-reports', show: prisonReportsPermission.hasPermission && !prisonReportsPermission.loading },
    ],
    [prisonReportsPermission, accessFromPrison, isInmate, showReports, showAdmin, showLabs]
  )
  const visibleTabs = tabs.filter((tab) => tab.show)

  const currentTabIndex = useMemo(() => {
    const index = visibleTabs.findIndex((tab) => (tab.path === '/' ? pathname === '/' : pathname.startsWith(tab.path)))
    // For events user page and m-link page, return -1 to indicate no active tab
    if (index < 0 && (/^\/events\/[^/]+\/user(\/|$)/.test(pathname) || pathname === '/m-link')) {
      return -1
    }
    return index >= 0 ? index : 0
  }, [visibleTabs, pathname])

  return {
    currentTabIndex,
    visibleTabs,
    showTabs: visibleTabs.length > 0,
  }
}

export default useAppTabs
